import styled from '@emotion/styled'

export const Container = styled.div`
  background: white;
  border-radius: 8px;
  width: 500px;
  max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;

  h3 {
    margin: 0;
    font-size: 18px;
  }
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;

  &:hover {
    color: #333;
  }
`

export const Body = styled.div`
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
`

export const ItemInfo = styled.div`
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 13px;
  max-height: 150px;
  overflow-y: auto;
`

export const UploadArea = styled.div`
  border: 2px dashed #ddd;
  border-radius: 6px;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
  transition: all 0.2s;

  &:hover {
    border-color: #999;
    background: #f9f9f9;
  }

  span {
    font-size: 40px;
    display: block;
    margin-bottom: 10px;
  }

  p {
    margin: 0;
  }
`

export const FileInput = styled.input`
  display: none;
`

export const UploadLabel = styled.label`
  cursor: pointer;
`

export const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 200px;
  display: block;
  margin: 0 auto 15px;
  border-radius: 4px;
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
  border-top: 1px solid #eee;
  gap: 10px;
`

export const Button = styled.button<{ $cancel?: boolean }>`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  background: ${({ $cancel }) => ($cancel ? 'white' : '#4a90e2')};
  border: 1px solid ${({ $cancel }) => ($cancel ? '#ddd' : '#4a90e2')};
  color: ${({ $cancel }) => ($cancel ? '#333' : 'white')};

  &:disabled {
    background: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: ${({ $cancel }) => ($cancel ? '#f5f5f5' : '#3a7bc8')};
  }
`
